var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureAutoOfferFilled = function SvgFeatureAutoOfferFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M15.205 4.263a8.375 8.375 0 0 0-9.127 1.815.625.625 0 1 1-.884-.884 9.625 9.625 0 1 1 0 13.612.625.625 0 0 1 .884-.884 8.375 8.375 0 1 0 9.127-13.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M6.5 9.002a.5.5 0 0 1-.5.5H3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5M3 14.503a.5.5 0 0 0 0 1h2a.5.5 0 1 0 0-1H3M5.5 12a.5.5 0 0 1-.5.5H2a.5.5 0 1 1 0-1h3a.5.5 0 0 1 .5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M15.498 8.502h-5.447A1.5 1.5 0 0 0 8.614 9.57l-1.05 3.5A1.5 1.5 0 0 0 9 15h5.448a1.5 1.5 0 0 0 1.437-1.068l1.05-3.5a1.5 1.5 0 0 0-1.437-1.931m-1.413 2.082a.375.375 0 0 1-.168.503l-2 1a.375.375 0 0 1-.433-.07l-1-1a.375.375 0 1 1 .53-.53l.81.808 1.758-.879a.375.375 0 0 1 .503.168",
    clipRule: "evenodd"
  })));
};
export default SvgFeatureAutoOfferFilled;